import React, { useEffect } from "react";
import ConnectCard from "../../components/ConnectCard/ConnectCard";
import GrievanceCard from "../../components/GrievanceCard/GrievanceCard";
import { Observer, observer } from "mobx-react";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
import SecondaryRMCard from "../../components/ConnectCard/SecondaryRMCard";
// import ProfileStore2 from "../../store/ProfileStore2";

const SecondaryRmWithGrievanceCard = ({ data, connectData }) => {
  let containerClass = {
    wrapperClass: "second-grid-wrapper",
    connectCardWrapperClass: "connect_card_outside secondary-rm-card",
    grievanceCardWrapperClass: "",
  };
  if (connectData.length) {
    containerClass = {
      wrapperClass: "second-grid-wrapper with-primary-rm-details",
      connectCardWrapperClass: "connect_card_outside secondary-rm-small-card",
      grievanceCardWrapperClass: "grievance-card-wrapper",
    };
  }

  return (
    <div className={containerClass.wrapperClass}>
      {data ? (
        <SecondaryRMCard
          item={data}
          photo={null}
          name={data.name}
          position={data.role}
          phoneNum={data.contactNo}
          emailId={data.emailId}
          wrapperClass={containerClass.connectCardWrapperClass}
        />
      ) : (
        <></>
      )}
      <div className={containerClass.grievanceCardWrapperClass}>
        <GrievanceCard />
      </div>
    </div>
  );
};

const Connect = observer(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    // ProfileStore2.getProfileImage(UserStore.userData?.profile_pic);
    UserStore.getPointOfConnect({
      onFail: (error) => {
        AuthStore.updateLoadingFullScreen(false);
        UserStore.setConnectData([]);
      },
      onSuccess: (data) => {
        UserStore.setConnectData(data);
        AuthStore.updateLoadingFullScreen(false);
      },
    });

    UserStore.getSecondaryRMDetails({
      onSuccess: (data) => {
        UserStore.setUserStoreData("secondaryRMDetails", {
          isLoading: false,
          error: "",
          data: data[0],
        });
      },
      onFail: (error) => {
        UserStore.setUserStoreData("secondaryRMDetails", {
          isLoading: false,
          error,
          data: null,
        });
      },
    });
  }, []);

  return (
    <Observer>
      {() => (
        <>
          <PageTitle title={"Connect"} />
          {AuthStore.isLoadingFullScreen ||
          UserStore.secondaryRMDetails.isLoading ||
          !UserStore.isHydrated ? (
            <LoadingScreen />
          ) : (
            <div className="connect_outside_main">
              <div className="connect_inside">
                <PageHeading
                  headingClass="connect_title"
                  headingText="Connect"
                />
                <div className="connects_cards_div">
                  {UserStore.connectData?.map((item) => (
                    <ConnectCard
                      item={item}
                      photo={UserStore.connectImages[item.id]}
                      name={item.name}
                      position={item.role}
                      phoneNum={item.contactNo}
                      emailId={item.emailId}
                    />
                  ))}
                  <SecondaryRmWithGrievanceCard
                    data={UserStore.secondaryRMDetails.data}
                    connectData={UserStore.connectData}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </Observer>
  );
});

export default Connect;
